import { Box, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from 'theme/Color';

const ContactHeader = ({ selectedData }: { selectedData: any }) => {
  return (
    <Box sx={{ display: 'flex', gap: '16px' }}>
      {selectedData?.profileImageUrl ? (
        <img
          src={selectedData?.profileImageUrl}
          alt='Lead Avatar'
          width={60}
          height={60}
          style={{ borderRadius: '14px' }}
        />
      ) : (
        <Box
          sx={{
            borderRadius: '14px',

            width: { xs: '60px', xl: '60px' },
            height: { xs: '60px', xl: '60px' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: selectedData?.profileImageUrl ? 'transparent' : zeplinColor.Brand1,
          }}
        >
          <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
            {selectedData?.name
              ?.split(' ')
              .map((value: any, index: number) =>
                selectedData?.name &&
                (index === 0 || index === selectedData?.name?.split(' ').length - 1)
                  ? value[0]
                  : '',
              )}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Typography
          variant='heading2'
          sx={{
            color: zeplinColor.BasicBlack,
            wordBreak: 'break-word',
          }}
        >
          {selectedData?.name || 'N/A'}
        </Typography>

        <Typography variant='body2' sx={{ color: zeplinColor.Brand1 }}>
          {selectedData?.email || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactHeader;
